import { RECORD_CONSTANTS } from "../../../constants";

export const mergeViewsWithAttributeOverlay = (
  baseViews,
  attributeOverlay,
  linksOverlay = null
) => {
  const hasAttributeOverlay = Boolean(attributeOverlay);
  const hasLinksOverlay = Boolean(linksOverlay);

  if (!hasAttributeOverlay && !hasLinksOverlay) {
    return baseViews;
  }

  let needsMerge = false;
  const merged = new Set(baseViews);

  if (hasAttributeOverlay) {
    if (
      attributeOverlay.date &&
      !baseViews.has(RECORD_CONSTANTS.VIEW_TYPES.CALENDAR)
    ) {
      merged.add(RECORD_CONSTANTS.VIEW_TYPES.CALENDAR);
      needsMerge = true;
    }

    const hasTaskOverlay =
      attributeOverlay.isComplete ||
      attributeOverlay.dueDate ||
      attributeOverlay.priority;

    if (hasTaskOverlay && !baseViews.has(RECORD_CONSTANTS.VIEW_TYPES.TASK)) {
      merged.add(RECORD_CONSTANTS.VIEW_TYPES.TASK);
      needsMerge = true;
    }

    if (
      attributeOverlay.location &&
      !baseViews.has(RECORD_CONSTANTS.VIEW_TYPES.MAP)
    ) {
      merged.add(RECORD_CONSTANTS.VIEW_TYPES.MAP);
      needsMerge = true;
    }
  }

  if (
    hasLinksOverlay &&
    !baseViews.has(RECORD_CONSTANTS.VIEW_TYPES.GRAPH)
  ) {
    merged.add(RECORD_CONSTANTS.VIEW_TYPES.GRAPH);
    needsMerge = true;
  }

  return needsMerge ? merged : baseViews;
};

export default mergeViewsWithAttributeOverlay;
